export default {
  // 获取手机验证码
  getAuthCode: '/member/anonymous/amc/getAuthCode',
  // 增加积分
  addScore: '/member/anonymous/amc/unifiedScore',
}